// SAF-65 (31 Oct 2026) — role tiers, mirroring backend/auth.py. One place, so
// no screen re-inlines `role === "admin"` (which silently left out super_admin).
//
// SUPER_ADMIN_ROLES still includes the legacy "admin" string because every
// admin account today carries it; narrow it here and in auth.py together once
// those accounts are migrated to "super_admin".
export const ADMIN_ROLES = ["admin", "super_admin"];
export const SUPER_ADMIN_ROLES = ["super_admin", "admin"];
export const STAFF_ROLES = ["admin", "super_admin", "broker", "junior_broker"];

const roleOf = (userOrRole) =>
  String((typeof userOrRole === "string" ? userOrRole : userOrRole?.role) || "").toLowerCase();

export const isAdminRole = (userOrRole) => ADMIN_ROLES.includes(roleOf(userOrRole));
export const isSuperAdminRole = (userOrRole) => SUPER_ADMIN_ROLES.includes(roleOf(userOrRole));
export const isStaffRole = (userOrRole) => STAFF_ROLES.includes(roleOf(userOrRole));
